import { StateToken } from '@ngxs/store';

import { UnitTemplateFilters, UnitTemplateGroup, UnitTemplateGroups, UnitTemplatesWithFilters } from '../../models';

export interface UnitSelectionStateModel {
  unitTemplateWithFilters: UnitTemplatesWithFilters;
  filters: UnitTemplateFilters;
  groups: UnitTemplateGroups;
  selectedGroup: UnitTemplateGroup;
  pagination: { page: number; pageSize: number; total: number };
  isLoadingMore: boolean;
}

export const PROJECT_UNIT_TEMPLATE_STATE_TOKEN = new StateToken<UnitSelectionStateModel>('unitSelection');
